module.exports = __webpack_public_path__ + "img/block_1.57cc3a63.webp";